import React, {useEffect, useState} from 'react';
import '../styles/style.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faPhone } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import {
  faFacebook,
  faInstagram,
  faTwitter,
  faLinkedin,
} from '@fortawesome/free-brands-svg-icons';
import SiteLogo from '../assets/images/logo.png';
import axios from "axios";
import BASE from "../config";

const Footer = () => {


  // const [pages, SetPages] = useState("");
  // useEffect(() => {
  //   axios.get(BASE.BASE_API_URL+'/api/admin-pages').then(res =>{
  //     console.log("Admin Pages",res);
  //   })
  //
  // },[])


  return (
    <div className="footer">
      <div className="container">
        <div className="row">
          <div className="col-md-10">
            <img src={SiteLogo} alt="Logo" />
          </div>
          <div className="col-md-2">
            <div className="social-media-links" style={{ display: 'flex', gap: '45px' }}>
              <a href="#" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faFacebook} size="1x" style={{ color: 'white' }} />
              </a>
              <a href="https://www.instagram.com/sunboundvillas/?hl=en" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faInstagram} size="1x" style={{ color: 'white' }} />
              </a>
              <a href="http://twitter.com/SunboundVillas" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faTwitter} size="1x" style={{ color: 'white' }} />
              </a>
              <a href="#" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faLinkedin} size="1x" style={{ color: 'white' }} />
              </a>
            </div>
          </div>
        </div>
        <div className='row-bordered'></div>
        <div className="row mt-5">
          <div className="col-md-2 col-lg-2 col-xs-2 col-sm-6 col-6">
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/resorts">Resorts</Link></li>
            </ul>
          </div>
          <div className="col-md-2 col-lg-2 col-xs-2 col-sm-6 col-6">
            <ul>
              {/*<li>Help</li>*/}
              <li><Link to="/how-to-book">How to Book</Link></li>
              <li><Link to="/contact">Contact us</Link></li>
            </ul>
          </div>
          <div className="col-md-4 col-lg-4 col-xs-4 col-sm-12 col-12">
            <ul className='border_padding'>
              <li>PORTUGAL</li>
              <li>
                <div style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
                  <FontAwesomeIcon icon={faMapMarkerAlt} style={{ color: "#F6897A", marginRight: "10px" }} />
                  <span>Sunbound Villas Rua Vale Formoso, Edifcio Poço Novo Loja nr 12 8135-148, Almancil</span>
                </div>
              </li>
              <li>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <FontAwesomeIcon icon={faPhone} style={{ color: "#F6897A", marginRight: "10px" }} />
                  <span>00 351 289099457</span>
                </div>
              </li>
            </ul>
          </div>
          <div className="col-md-4 col-lg-4 col-xs-4 col-sm-12 col-12">
            <ul>
              <li>IRELAND</li>
              <li>
                <div style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
                  <FontAwesomeIcon icon={faMapMarkerAlt} style={{ color: "#F6897A", marginRight: "10px" }} />
                  <span>Sunbound Villas 37 Heather Road, Sandyford Business District, Dublin 18</span>
                </div>
              </li>
              <li>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <FontAwesomeIcon icon={faPhone} style={{ color: "#F6897A", marginRight: "10px" }} />
                  <span>00 353 1 2130701</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div className='row-bordered'></div>
        <div className="row mt-4">
          <div className="col-md-9">
            <p className='Copyright'>Copyright © 2026. Sunboundvillas | All Rights Reserved.</p>
          </div>
          <div className="col-md-3">
            <p className='Copyright'><Link to="/privacy_policy">Privacy Policy</Link> <Link to="/terms-and-conditions">Terms & Conditions</Link></p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;